import * as React from 'react';

function SvgPlay(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 15.45l-15-9v18l15-9zM9.5 21.8V9.099l10.584 6.351L9.5 21.8z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  );
}

export default SvgPlay;
